import { render, staticRenderFns } from "./i-modal-wrapper.vue?vue&type=template&id=7e97a4e2"
import script from "./i-modal-wrapper.vue?vue&type=script&lang=js"
export * from "./i-modal-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports